
import { useListadoTodasVentasSave } from "../../../hooks/cache";
import { CargandoMedio } from "../../components";
import { LayoutCrearDoc } from "../../layouts";
import { TablaListadoVentasGuardadas } from "../components";







export const ListadoVentaGuardada = () => {

    const { data, isLoading } = useListadoTodasVentasSave();



    return (

        <LayoutCrearDoc titulo='Ventas Guardadas' add={false}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de ventas guardadas..." />
            :   <TablaListadoVentasGuardadas data={data || []} />
            }
        </LayoutCrearDoc>

    )
}
